import React from 'react'

function payOut() {
  return (
    <div>payOut</div>
  )
}

export default payOut